<template>
  <div class="detail">
    <section class="section section--booking-engine">
      <trigger-booking-engine :is_open="is_open" @toggle="is_open = $event" />
      <booking-engine size="sm" :is_open="is_open" @search="handleSearch" />
    </section>
    <b-container v-if="!loading" class="mt-4 mb-2">
      <b-row>
        <b-col>
          <button-back :forwards_only="forwards_only" />
        </b-col>
      </b-row>
    </b-container>
    <b-container>
      <validation-observer v-slot="{ invalid }">
        <section v-if="loading" class="section section--loader">
          <loader size="large" :show_timing_slot="true" />
        </section>
        <b-row>
          <b-col sm="12" md="7" lg="8" xl="9">
            <div v-if="!loading && priced_flight_offer">
              <content-section no_margin>
                <flight-pad :flight_offer="priced_flight_offer" />
              </content-section>

              <!-- bagaglio a mano -->
              <personal-bags-info
                v-if="
                  get_config(
                    'guiSettings.customizations.showCabinBagsInfo',
                    false
                  )
                "
                :flight_offer="priced_flight_offer"
              />
            </div>
            <!-- Branded Fare Upsell: importante render_slider! nasconde lo slider delle branded, reinizializza slick se/qando serve ed evita l'unmount del componente e le conseguenti chiamate indesiderate a get_flight_offers_upsell() -->
            <branded-fare-upsell
              v-if="enable_branded_upsell"
              :page_loading="loading"
              :flight_offer="priced_flight_offer || flight_offer"
            />
            <div v-if="!loading && priced_flight_offer">
              <!-- flex bags -->
              <additional-bags-panel
                v-if="
                  bags &&
                    !has_ancillaries_as_step &&
                    !get_config(
                      'guiSettings.customizations.showExtraBagsTable',
                      false
                    )
                "
                :flexible_bags="flexible_bags"
                :has_pending_bag_changes="has_pending_bag_changes"
                :bags="bags"
                :traveler_details="traveler_details"
                :flight_offer="flight_offer"
                :handle_add_flexible_bag_to_flight_offer="
                  handle_add_flexible_bag_to_flight_offer
                "
                :flexible_bags_updated="flexible_bags_updated"
              />
              <additional-bags-table
                v-if="
                  bags &&
                    !has_ancillaries_as_step &&
                    get_config(
                      'guiSettings.customizations.showExtraBagsTable',
                      false
                    )
                "
                :flexible_bags="flexible_bags"
                :flexible_bags_update_key="flexible_bags_update_key"
                :has_pending_bag_changes="has_pending_bag_changes"
                :bags="bags"
                :traveler_details="traveler_details"
                :flight_offer="flight_offer"
                :handle_add_flexible_bag_to_flight_offer="
                  handle_add_flexible_bag_to_flight_offer
                "
                :flexible_bags_updated="flexible_bags_updated"
              />

              <!-- sidebar resume -->
              <div v-if="is_mobile()" class="detail--panel side">
                <sidebar-resume :flight_offers="[priced_flight_offer]" />
              </div>

              <!-- dett. passeggeri -->
              <content-section
                icon="occupants"
                title="Dettagli dei Passeggeri"
                description="Inserisci i dati esattamente come compaiono sul documento di identità o sul
                    passaporto. Così eviterai problemi al check-in!"
              >
                <!-- traveler details -->
                <b-row class="mb-5">
                  <travelers-details-form
                    :contact_details="contact_details"
                    :flight_offer="flight_offer"
                    :traveler_details="traveler_details"
                    :committed_traveler_ages="committed_traveler_ages"
                  />
                </b-row>

                <div class="detail__disclaimers">
                  <b-row>
                    <b-col>
                      <vb-checkbox
                        :vb_options="{
                          value: disclaimer_destination_requirements,
                          text: `Ho verificato autonomamente le condizioni legali,
                            doganali e sanitarie di accesso nella località o nel
                            Paese di destinazione e sono a conoscenza della
                            documentazione necessaria (ho consultato il sito
                            <a
                              href='https://www.viaggiaresicuri.it/home'
                              target='_blank'
                              >Viaggiare sicuri</a
                            >
                            e quelli delle autorità preposte)
                          </span>`,
                        }"
                        @change="
                          (val) => (disclaimer_destination_requirements = val)
                        "
                      />
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col>
                      <vb-checkbox
                        :vb_options="{
                          value: disclaimer_travellers_names,
                          text: `Ho verificato che i dati dei viaggiatori corrispondono
                            a quelli riportati nei documenti che verranno
                            utilizzati per l'imbarco e che Nome, Cognome e Data di
                            nascita sono stati inseriti negli appositi campi
                            escludendo anche eventuali inversioni.`,
                        }"
                        @change="(val) => (disclaimer_travellers_names = val)"
                      />
                    </b-col>
                  </b-row>
                </div>
              </content-section>

              <!-- disclaimer / checkout -->
              <div
                v-if="config.integration.welfare"
                class="detail--panel mt-4"
                compact
                noborder
              >
                <b-row>
                  <b-col>
                    <vb-checkbox
                      :vb_options="{
                        value: disclaimer,
                        text: `<span class='checkbox-label ml-1'>
                          In qualità di Beneficiario della prestazione
                          (Passeggero 1) dichiaro di aver letto e di accettare
                          l'<a :href='config.site.urlPrivacy' target='_blank'
                            >informativa privacy</a
                          >
                          fornendo il consento al trattamento dei dati personali
                          comunicati
                        </span>`,
                      }"
                      @change="(val) => (disclaimer = val)"
                    />
                  </b-col>
                </b-row>
              </div>

              <btn-checkout
                id="btn-checkout-content"
                class="detail__btn-checkout"
                :fullwidth="false"
                :conditions="
                  invalid ||
                    checkout_btn_conditions ||
                    get_availability(get_markup(flight_offer).mu_price)
                      .show_credit_alert
                "
                :popover="
                  get_availability(get_markup(flight_offer).mu_price)
                    .show_credit_alert
                    ? ''
                    : get_checkout_btn_popover({
                      missing_details: invalid || !accepted_disclaimers,
                      must_update: has_pending_bag_changes,
                    })
                "
                :copy="'Continua'"
                @handle_data="handle_travel_data()"
              />
              <p
                v-if="
                  get_availability(get_markup(flight_offer).mu_price)
                    .show_credit_alert
                "
                v-b-popover.hover.bottom="
                  'Il tuo credito welfare non è sufficiente ad acquistare questa soluzione'
                "
                class="credit-warning text-center text-danger mt-2 mb-1"
              >
                <vb-icon
                  name="info"
                  class="text-danger"
                  :color="sass('danger')"
                  :size="16"
                />
                Credito insufficiente
              </p>
            </div>
          </b-col>

          <!-- sidebar -->
          <b-col sm="12" md="5" lg="4" xl="3">
            <div
              v-if="!loading && priced_flight_offer"
              class="sidebar sticky-top"
            >
              <div
                v-if="!is_mobile()"
                class="detail--panel detail--panel-sidebar pt-0"
                compact
              >
                <sidebar-resume :flight_offers="[priced_flight_offer]" />
                <btn-checkout
                  id="btn-checkout-sidebar"
                  :conditions="
                    invalid ||
                      checkout_btn_conditions ||
                      get_availability(get_markup(flight_offer).mu_price)
                        .show_credit_alert
                  "
                  :popover="
                    get_availability(get_markup(flight_offer).mu_price)
                      .show_credit_alert
                      ? ''
                      : get_checkout_btn_popover({
                        missing_details: invalid || !accepted_disclaimers,
                        must_update: has_pending_bag_changes,
                      })
                  "
                  :copy="'Continua'"
                  @handle_data="handle_travel_data()"
                />
                <p
                  v-if="
                    get_availability(get_markup(flight_offer).mu_price)
                      .show_credit_alert
                  "
                  v-b-popover.hover.bottom="
                    'Il tuo credito welfare non è sufficiente ad acquistare questa soluzione'
                  "
                  class="credit-warning text-center text-danger mt-2 mb-1"
                >
                  <vb-icon
                    name="info"
                    class="text-danger"
                    :color="sass('danger')"
                    :size="16"
                  />
                  Credito insufficiente
                </p>
              </div>
            </div>
          </b-col>
        </b-row>
      </validation-observer>
    </b-container>
  </div>
</template>

<script>
  import Vue from 'vue';
  import { mapState } from 'vuex';
  import { number } from 'mathjs';
  import { is_mobile, get_config } from '@/utilities';
  import {
    get_offer_details,
    get_extra_bags,
    has_capability_for,
    add_charged_bags,
    book_held,
  } from '@liveflight/providers';
  import {
    parse_flight_offers_date,
    get_flight_offer_dates,
  } from '@liveflight/utilities/dates';
  import {
    parse_flight_offer_for_ecommerce_item,
    formatPassengerName,
  } from '@liveflight/utilities/mixins';
  import {
    reverse_date,
    get_availability,
    custom_event,
    log,
  } from '@/utilities/commons';
  import { get_flight_order_body } from '@liveflight/providers/amadeus/checkout';
  import {
    get_markup,
    apply_markup_to_number,
  } from '@liveflight/utilities/price';
  import {
    is_adult,
    is_infant,
    set_infant_associated_adult_id,
    store_key_age,
    trim_traveler_strings,
  } from '@liveflight/utilities/travelers';
  import {
    build_store_key,
    get_stored_value,
  } from '@/utilities/persistent-inputs';

  import BookingEngine from '@liveflight/components/blocks/booking-engine/booking-engine';
  import SidebarResume from '@liveflight/components/blocks/resume/resume';
  import FlightPad from '@liveflight/components/blocks/flight-pad/flight-pad';
  import BrandedFareUpsell from '@liveflight/components/blocks/details/branded-fare-upsell/branded-fare-upsell';
  import BtnCheckout from '@liveflight/components/atoms/btn-checkout';
  import TravelersDetailsForm from '@liveflight/components/blocks/details/travelers-details-form.vue';
  import AdditionalBagsPanel from '@liveflight/components/blocks/additional-bags/additional-bags-panel.vue';
  import AdditionalBagsTable from '@liveflight/components/blocks/additional-bags/additional-bags-table.vue';
  import PersonalBagsInfo from '@liveflight/components/blocks/additional-bags/personal-bags-info.vue';
  import ContentSection from '@liveflight/components/blocks/wrappers/content-section.vue';
  import TriggerBookingEngine from '@components/atoms/trigger-booking-engine.vue';

  export default {
    name: 'detail',
    components: {
      'booking-engine': BookingEngine,
      'flight-pad': FlightPad,
      'sidebar-resume': SidebarResume,
      'branded-fare-upsell': BrandedFareUpsell,
      'btn-checkout': BtnCheckout,
      'travelers-details-form': TravelersDetailsForm,
      'additional-bags-panel': AdditionalBagsPanel,
      'additional-bags-table': AdditionalBagsTable,
      'personal-bags-info': PersonalBagsInfo,
      'content-section': ContentSection,
      'trigger-booking-engine': TriggerBookingEngine,
    },
    props: {},
    data() {
      return {
        is_open: false,
        details_loading: true,
        book_loading: false,
        priced_flight_offer: null,
        leaving_on_error: false,
        default_grand_total: 0,
        config: Vue.prototype.$config,
        //bags: {},//popolato con included.bags, per poter accedere ai bagagli in modo rapido senza passare per la gerarchia traverler->itinerary->flexible_bag
        //flexible_bags: {},
        flexible_bags_update_key: 0, // counter for forcing checkbox re-render in table view
        confirmed_bags_snapshot: '{}', // serialized bag selection after last successful reprice — used for dirty checking
        disclaimer: process.env.VUE_APP_MODE === 'development',
        disclaimer_destination_requirements:
          process.env.VUE_APP_MODE === 'development',
        disclaimer_travellers_names: process.env.VUE_APP_MODE === 'development',
        enable_branded_upsell: false, //  get_config('guiSettings.brandedUpsell.enabled', false),
        branded_updated: false,
        previous_route_name: '',
        originalInfantHoldingConfiguration: JSON.stringify({}),
      };
    },
    computed: {
      ...mapState('liveflight', [
        'traveler_details',
        'flight_offer',
        'has_flexible_bags_last_selection',
        'flexible_bags',
        'bags',
        'committed_traveler_ages',
      ]),
      // Either the reprice or the book_held call owns its own flag —
      // the template only ever reads `loading`.
      loading() {
        return this.details_loading || this.book_loading;
      },
      has_ancillaries_as_step() {
        return has_capability_for(this.flight_offer, 'ancillariesAsStep');
      },
      forwards_only() {
        return has_capability_for(this.flight_offer, 'forwardsOnly');
      },
      contact_details: {
        get() {
          if (
            Object.keys(this.$store.state.liveflight.contact_details).length ===
            0
          ) {
            const { firstname = '', lastname = '' } = this.get_config(
              'integration',
              {}
            );
            const contacts_default = {
              firstname,
              middlename: '',
              lastname,
              second_lastname: '',
              email: '',
              phone: '',
              country_calling_code:
                this.get_stored_value(
                  this.build_store_key(
                    this.$route.name,
                    '1',
                    'ADULT',
                    'phone_code'
                  )
                ) || '39',
              address: '',
              zipcode: '',
              city: '',
              country_code:
                this.get_stored_value(
                  this.build_store_key(
                    this.$route.name,
                    '1',
                    'ADULT',
                    'country_code'
                  )
                ) || 'IT',
            };
            this.$store.commit('liveflight/contact_details', contacts_default);
          }
          return this.$store.state.liveflight.contact_details;
        },
        set(value) {
          this.$store.commit('liveflight/contact_details', value);
        },
      },
      accepted_disclaimers() {
        if (this.config.integration.welfare) {
          // ci sono 2 checkbox/copy specifici per welfare (privacy/disclaimer)
          return (
            this.disclaimer &&
            this.disclaimer_destination_requirements &&
            this.disclaimer_travellers_names
          );
        }
        return (
          this.disclaimer_destination_requirements &&
          this.disclaimer_travellers_names
        );
      },
      checkout_btn_conditions() {
        return !this.accepted_disclaimers || this.has_pending_bag_changes;
      },
      current_bags_snapshot() {
        // Vue 2 can't track dynamically-added properties on flexible_bags (added via
        // initialize_checked_flexible_bags after initial observation). Reading the counter
        // creates a reactive dependency so this computed re-evaluates when bags change.
        // eslint-disable-next-line no-unused-expressions
        this.flexible_bags_update_key;
        const snapshot = {};
        Object.keys(this.flexible_bags).forEach((t) => {
          snapshot[t] = {};
          Object.keys(this.flexible_bags[t]).forEach((i) => {
            snapshot[t][i] = {};
            Object.keys(this.flexible_bags[t][i]).forEach((b) => {
              if (this.flexible_bags[t][i][b].added) {
                snapshot[t][i][b] = true;
              }
            });
          });
        });
        return JSON.stringify(snapshot);
      },
      has_pending_bag_changes() {
        return this.current_bags_snapshot !== this.confirmed_bags_snapshot;
      },
      heldPassengers() {
        const held = {};
        this.flight_offer.travelerPricings.filter(is_infant).forEach((i) => {
          held[i.travelerId] = i.associatedAdultId;
        });
        return held;
      },
      adults() {
        return this.traveler_details.filter(is_adult);
      },
    },
    watch: {
      flight_offer: {
        handler() {
          // handle_travel_data commits the priced offer on its way out;
          // that commit must not kick off one more reprice.
          if (this.book_loading || this.leaving_on_error) return;
          this.branded_updated = true;
          this.get_detail_data();
        },
        deep: true,
      },
    },
    created() {
      this.number = number;
      this.get_flight_order_body = get_flight_order_body;
      this.get_markup = get_markup;
      this.apply_markup_to_number = apply_markup_to_number;
      this.get_flight_offer_dates = get_flight_offer_dates;

      this.reverse_date = reverse_date;
      this.parse_flight_offers_date = parse_flight_offers_date;
      this.is_mobile = is_mobile;
      this.get_markup = get_markup;
      this.get_availability = get_availability;
    },
    beforeRouteEnter(to, from, next) {
      next((vm) => {
        vm.previous_route_name = from.name === 'results' ? '' : from.name;
      });
    },
    mounted() {
      this.get_detail_data();
      this.originalInfantHoldingConfiguration = JSON.stringify(
        this.heldPassengers
      );
    },
    methods: {
      build_store_key,
      get_stored_value,
      formatPassengerName,
      get_config,
      set_infant_associated_adult_id,
      handleSearch() {
        this.is_open = false;
        this.$router.push({ name: 'results' });
      },
      get_checkout_btn_popover(conditions) {
        if (!conditions) return '';
        if (conditions.missing_details) {
          return 'Per continuare devi accettare le condizioni d’uso e di privacy nonché avere inserito i dettagli di contatto e dei viaggiatori.';
        }
        if (conditions.not_accepted_disclaimers) {
          return 'Prima di continuare, accettare gli appositi disclaimer.';
        }
        if (conditions.must_update) {
          return 'Non hai ancora aggiunto i bagagli extra che hai selezionato. Clicca sul bottone Aggiorna che trovi nella sezione Bagagli in stiva extra.';
        }
        return '';
      },

      get_markup,
      flexible_bags_updated(value, travel_info) {
        // aggiorno la struttura dati per il bagaglio su cui ho cliccato
        const travel_bags = this.flexible_bags[travel_info.traveler_index];
        if (!travel_bags) return;

        const itinerary_bags = travel_bags[travel_info.itinerary_index];
        if (!itinerary_bags) return;

        const bag = itinerary_bags[travel_info.bag_index];
        if (!bag) return;

        this.flexible_bags[travel_info.traveler_index][
          travel_info.itinerary_index
        ][travel_info.bag_index].added = value;

        if (!travel_info.skip_options_cleanup) {
          // caso bookableByItinerary==true con value==false (sto deselezionando un bagaglio) => non fare nient'altro
          // caso bookableByItinerary==true con value==true (sto selezionando un bagaglio) => deseleziono tutti gli altri bagagli per quel passeggero su quell'itinerario
          if (travel_info.bookableByItinerary && value) {
            Object.keys(
              this.flexible_bags[travel_info.traveler_index][
                travel_info.itinerary_index
              ]
            ).forEach((bag) => {
              if (String(bag) !== String(travel_info.bag_index)) {
                this.flexible_bags[travel_info.traveler_index][
                  travel_info.itinerary_index
                ][bag].added = false;
              }
            });
          }

          if (!travel_info.bookableByItinerary) {
            // caso bookableByItinerary==false => imposto lo stesso value anche per gli altri itinerari per questo traveler
            Object.keys(this.flexible_bags[travel_info.traveler_index]).forEach(
              (itinerary) => {
                const itinerary_index = number(itinerary);
                this.flexible_bags[travel_info.traveler_index][itinerary_index][
                  travel_info.bag_index
                ].added = value;
                // caso bookableByItinerary==false con value==true (sto selezionando un bagaglio) => deseleziono tutti gli altri bagagli per quel passeggero su quell'itinerario
                if (value) {
                  Object.keys(
                    this.flexible_bags[travel_info.traveler_index][
                      travel_info.itinerary_index
                    ]
                  ).forEach((bag) => {
                    if (String(bag) !== String(travel_info.bag_index)) {
                      this.flexible_bags[travel_info.traveler_index][
                        itinerary_index
                      ][bag].added = false;
                    }
                  });
                }
              }
            );
          }

          // deseleziono ( => metto added=false ) eventuali bagagli diversi da quello che sto aggiungendo che siano giù presenti su itinerari diversi dello stesso passeggero
          if (value) {
            Object.keys(this.flexible_bags[travel_info.traveler_index]).forEach(
              (itinerary) => {
                const itinerary_index = number(itinerary);
                if (
                  String(itinerary_index) ===
                  String(travel_info.itinerary_index)
                ) {
                  return;
                }
                Object.keys(
                  this.flexible_bags[travel_info.traveler_index][
                    itinerary_index
                  ]
                ).forEach((bag) => {
                  if (String(bag) === String(travel_info.bag_index)) return;
                  this.flexible_bags[travel_info.traveler_index][
                    itinerary_index
                  ][bag].added = false;
                });
              }
            );
          }
        }
        // aggiorno la key per forzare il re-render del tag
        this.flexible_bags_update_key += 1;
      },
      handle_add_flexible_bag_to_flight_offer(flight_offer, flexible_bags) {
        // This triggers a get_detail_data call because of the watcher
        this.$store.commit(
          'liveflight/flight_offer',
          add_charged_bags(flight_offer, flexible_bags)
        );
      },
      get_detail_data() {
        this.scroll_top();
        this.details_loading = true;
        this.flexible_bags_update_key = 0;

        // Guard: flight_offer deve essere un oggetto valido con id (non un array vuoto o un oggetto vuoto da localStorage corrotto)
        if (!this.flight_offer || !this.flight_offer.id) {
          this.leave_on_error();
          return;
        }

        //se arrivo dalla ricerca o da un cambio di tariffa, i bagagli nello state sono appena stati resettati (sia bags, sia flexible_bags)
        //se torno indietro dal checkout, voglio mantenere bagagli e selezione che ho già nello state e poterli modificare
        const update_bags = Object.keys(this.flexible_bags).length === 0;

        get_offer_details(this.flight_offer)
          .then((priced_flight_offer) => {
            let enable_branded_upsell = get_config(
              'guiSettings.brandedUpsell.enabled',
              false
            );
            const { _possibleActions } = priced_flight_offer;
            if (enable_branded_upsell && _possibleActions) {
              enable_branded_upsell = _possibleActions.get_upsell;
            }
            this.enable_branded_upsell = enable_branded_upsell;
            // Hold the priced offer locally; the search-result version stays
            // in Vuex until handle_travel_data commits the priced one.
            this.priced_flight_offer = priced_flight_offer;
            this.default_grand_total = priced_flight_offer.price.grandTotal;
            // contact_details e traveler_details nello store vengono azzerati (come per i bagagli) quando seleziono una flight offer (vedi select_flight_offer() dentro flight-pad.vue) => INDEROGABILE, altrimenti creiamo problemi
            // se li trovo popolati nello state, vuol dire che sto tornando indietro con history back o che sto facendo una navigazione diretta a /detail utilizzando l'ultima flight offer che ho selezionato in precedenza
            // se contact_details e traveler_details sono popolati nello state, di conseguenza, fanno fede così come li trovo (in modo che l'utente possa modificarli senza riscriverli)
            const { travelerPricings = [] } = priced_flight_offer;
            // Contacts can come back while the travelers didn't: keeping that
            // state books one traveler without an id against N priced ones.
            const travelers_match_pricing =
              this.traveler_details.length === travelerPricings.length &&
              this.traveler_details.every(({ id }) =>
                travelerPricings.some(({ travelerId }) => travelerId === id)
              );
            if (
              Object.keys(this.$store.state.liveflight.contact_details)
                .length === 0 ||
              !travelers_match_pricing
            ) {
              this.$store.commit('liveflight/traveler_details', []);
              // traveler-details-form keys persistent inputs by a per-type
              // counter (grouped_ids), not by the provider's travelerId.
              const type_counters = {};
              travelerPricings.forEach((traveler) => {
                const { travelerType = '' } = traveler;
                type_counters[travelerType] =
                  (type_counters[travelerType] || 0) + 1;
                this.traveler_details.push({
                  show_datepicker: false,
                  traveler_type: traveler.travelerType,
                  id: traveler.travelerId,
                  firstname: '',
                  middlename: '',
                  lastname: '',
                  second_lastname: '',
                  gender:
                    this.get_stored_value(
                      this.build_store_key(
                        this.$route.name,
                        type_counters[travelerType],
                        travelerType,
                        store_key_age(
                          traveler,
                          this.committed_traveler_ages,
                          traveler.travelerId
                        ),
                        'gender'
                      )
                    ) || 'MALE', // NB, possono essere: MALE, FEMALE, UNSPECIFIED, UNDISCLOSED
                  birth: '',
                  //country_code: 'IT',
                  //passport: (process.env.VUE_APP_MODE == 'gerryxxx')? '12345678' : '',
                  //passport_issue_date: (process.env.VUE_APP_MODE == 'gerryxxx')? '2020-10-26' : '',
                  //passport_expiration_date: (process.env.VUE_APP_MODE == 'gerryxxx')? '2030-10-26' : '',
                  //email: (process.env.VUE_APP_MODE == 'gerryxxx')? 'dev@salabam.com' : '',
                });
              });
            } else {
              // Reactivity patch: $set, not index assignment, or pax 0 fields go non-reactive
              this.$set(this.traveler_details, 0, {
                ...(this.traveler_details[0] || {}),
                firstname: this.contact_details.firstname,
                lastname: this.contact_details.lastname,
              });
            }

            // gestione warnings bagagli
            let raise_bags_warning = false;

            if (!this.priced_flight_offer.price.additionalServices) {
              raise_bags_warning = true;
            } else if (
              this.priced_flight_offer.price.additionalServices.filter(
                (s) => s.type === 'CHECKED_BAGS'
              ).length === 0
            ) {
              raise_bags_warning = true;
            }

            const is_detail_route = this.$router.currentRoute.name === 'detail';

            // se ho appena cambiato tariffa mostro solo il warning senza l'errore
            if (this.branded_updated && update_bags) {
              this.branded_updated = false;
              raise_bags_warning = false;
              if (is_detail_route && this.has_flexible_bags_last_selection) {
                window.eventBus.$emit('got_toast_notification', {
                  text: 'Attenzione! Scegliendo la nuova tariffa i bagagli extra sono stati azzerati. Se desideri, seleziona di nuovo i bagagli extra.',
                  variant: 'warning',
                });
              }
              this.$store.commit(
                'liveflight/has_flexible_bags_last_selection',
                false
              );
            }

            if (raise_bags_warning) {
              let has_bags = false;
              // resetto i bagagli selezionati se ce ne sono
              Object.keys(this.flexible_bags).forEach((t) => {
                const traveler = this.flexible_bags[t];
                Object.keys(traveler).forEach((i) => {
                  const itinerary = traveler[i];
                  Object.keys(itinerary).forEach((b) => {
                    if (itinerary[b].added) has_bags = true;
                    itinerary[b].added = false;
                  });
                });
              });
              // lancio la notifica toast solo se ci sono bagagli che non è stato possibile prezzare
              if (has_bags && is_detail_route) {
                window.eventBus.$emit('got_toast_notification', {
                  text: 'La combinazione di bagagli che hai scelto non è consentita e NON sono stati aggiunti. Puoi acquistare bagagli anche per un solo passeggero ma se li acquisti a più passeggeri devono essere aggiunti sugli stessi itinerari.',
                  variant: 'danger',
                });
              }
            }

            if (!update_bags || this.has_ancillaries_as_step) {
              this.confirmed_bags_snapshot = this.current_bags_snapshot;
              this.details_loading = false;
              return;
            }

            return get_extra_bags(priced_flight_offer).then((bags_catalog) => {
              if (bags_catalog) {
                this.initialize_checked_flexible_bags(bags_catalog);
              }

              this.confirmed_bags_snapshot = this.current_bags_snapshot;

              custom_event({
                event: 'view_item',
                ecommerce: {
                  currency: 'EUR',
                  items: [
                    parse_flight_offer_for_ecommerce_item(priced_flight_offer),
                  ],
                  transaction_id: '',
                  affiliation: '',
                  value: 0, // Sum of (price * quantity) for all items.
                  tax: 0,
                  shipping: 0,
                  coupon: '',
                },
              });

              this.details_loading = false;
            });
          })
          .catch(this.leave_on_error);
      },
      leave_on_error() {
        if (this.leaving_on_error) return;
        this.leaving_on_error = true;
        this.priced_flight_offer = null;
        this.details_loading = false;
        this.$router.push({ name: 'results', params: { search_error: true } });
      },
      initialize_checked_flexible_bags(data_bags) {
        if (!data_bags) {
          return;
        }
        this.$store.commit('liveflight/bags', data_bags);
        this.priced_flight_offer.travelerPricings.forEach(
          (t, traveler_index) => {
            const traveler_flexible_bags = {};
            if (is_infant(t)) {
              return;
            }
            this.priced_flight_offer.itineraries.forEach(
              (i, itinerary_index) => {
                const itinerary_bags = {};
                Object.keys(this.bags).forEach((b) => {
                  itinerary_bags[b] = {
                    bag: this.bags[b],
                    added: false,
                  };
                  // Reconstruct the flexible bags object — find the first
                  // {type:'bag'} entry on the canonical additionalServices array.
                  (t.fareDetailsBySegment || []).forEach((segment_fare) => {
                    const { additionalServices = [] } = segment_fare || {};
                    const list = Array.isArray(additionalServices)
                      ? additionalServices
                      : [];
                    const bag_entry = list.find(
                      (entry) => entry && entry.type === 'bag'
                    );
                    if (bag_entry) {
                      const { quantity = 0, weight } = bag_entry;
                      const bags = Object.entries(itinerary_bags).filter(
                        (entry) => {
                          const bag = entry[1].bag || {};
                          return (bag.travelerIds || []).includes(t.travelerId);
                        }
                      );
                      for (let index = 0; index < bags.length; index += 1) {
                        const entry = bags[index];
                        const { bag } = entry[1];
                        if (
                          (bag.quantity || 1) === quantity &&
                          bag.weight === weight
                        ) {
                          itinerary_bags[entry[0]].added = true;
                        }
                      }
                    }
                  });
                });
                traveler_flexible_bags[itinerary_index] = itinerary_bags;
              }
            );
            this.flexible_bags[traveler_index] = traveler_flexible_bags;
          }
        );
      },
      toggle_birth_calendar(index) {
        this.traveler_details[index].show_datepicker =
          !this.traveler_details[index].show_datepicker;
      },
      handle_travel_data() {
        // Strip edge whitespace once here, before either provider payload is
        // built — Amadeus build_traveler and Kyte build_held_passengers both
        // read these straight from the store and reject padded values.
        const traveler_details = this.traveler_details.map(
          trim_traveler_strings
        );
        const contact_details = trim_traveler_strings(this.contact_details);

        // eslint-disable-next-line prefer-destructuring
        let priced_flight_offer = this.priced_flight_offer;
        if (
          this.originalInfantHoldingConfiguration !==
          JSON.stringify(this.heldPassengers)
        ) {
          priced_flight_offer = this.set_infant_associated_adult_id(
            priced_flight_offer,
            this.heldPassengers
          );
        }

        // get_flight_order_body still wants the legacy array shape — boundary-only,
        // that's an internal concern of amadeus/checkout.js.
        const flight_order_body = this.get_flight_order_body({
          flight_offers_pricing: [priced_flight_offer],
          traveler_details,
          contact_details,
        });

        const booking_data = {
          live_price: this.get_markup(priced_flight_offer).mu_price,
          flightCreateOrderBody: flight_order_body,
        };

        this.$store.commit('booking_data', booking_data);
        this.$store.commit('liveflight/traveler_details', traveler_details);
        this.$store.commit('liveflight/contact_details', contact_details);

        if (has_capability_for(priced_flight_offer, 'ancillariesAsStep')) {
          // Hold the loader through the whole book_held call so the page
          // doesn't flash interactive before the route push lands.
          this.book_loading = true;
          // The provider's bag catalog was cached against THIS reprice, so
          // leaving the search-result offer in the store would pair a stale
          // offer with a fresh catalog.
          this.$store.commit('liveflight/flight_offer', priced_flight_offer);
          book_held(
            priced_flight_offer,
            this.traveler_details,
            this.contact_details
          )
            .then(({ bookingId, expiresAt }) => {
              this.$store.commit('liveflight/held_booking', {
                id: bookingId,
                expires_at: expiresAt || '',
              });
              this.$router.push('ancillaries');
            })
            .catch((e) => {
              log('detail.book_held', e);
              window.eventBus.$emit('got_toast_notification', {
                text: 'Non siamo riusciti a riservare la tariffa.',
                variant: 'danger',
              });
              // Only remove loading on error for a seamless transition to next loading on ancillaries page
              this.book_loading = false;
            });
          return;
        }

        this.$store.commit('liveflight/flight_offer', priced_flight_offer);
        // Skip seat-selection when the provider does not advertise the
        // seatSelection capability (e.g. Kyte day-1) — would show an empty map.
        const seatmaps_enabled = this.get_config('endpoints.seatmaps', false);
        const provider_supports_seats = has_capability_for(
          priced_flight_offer,
          'seatSelection'
        );
        if (seatmaps_enabled && provider_supports_seats) {
          this.$router.push('seat-selection');
        } else {
          this.$router.push('checkout');
        }
      },
    },
  };
</script>
<style lang="scss">
  .detail {
    &__disclaimers {
      display: flex;
      flex-direction: column;
      gap: $grid-gutter-width * 2 / 3;
    }

    &__btn-checkout {
      display: flex;
      justify-content: center;
      margin-top: $grid-gutter-width;
      margin-bottom: $grid-gutter-width * 2;
    }

    .sidebar.sticky-top {
      @include media-breakpoint-up(md) {
        position: sticky;
        top: 20px;
        z-index: 0;
      }
    }

    .dp-toggle {
      position: relative;
      &--handler {
        background: transparent;
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        z-index: 1;
      }
    }

    &--panel {
      @extend .content-panel !optional;
      margin-bottom: 1rem !important;

      &--datepicker--birth {
        margin-top: 1rem;
        position: absolute;
        z-index: 2;
      }
    }

    .collapse--title {
      display: flex;
      justify-content: space-between;
      div.icon svg {
        transition: $transition-base;
        transform: rotate(180deg);
      }
      &.not-collapsed {
        margin-bottom: 1rem;
        div.icon svg {
          transform: rotate(0deg);
        }
      }
    }

    .bags {
      overflow: hidden;
      .table {
        thead {
          background-color: #f8f9fa;

          th {
            border-bottom: 0;
            text-align: center;
          }
        }
        tbody {
          border-bottom: 1px solid $gray-300;

          &:before {
            content: '';
            display: block;
            height: 10px;
          }

          & + tbody {
            border: 0;
          }
        }

        td {
          border-width: 0 0 1px;
          border-style: solid;
          border-color: $gray-300;
        }
      }
      &--traveler {
        max-width: 100px;
      }
    }

    .side {
      padding-top: 0;
    }

    // forzatura per avere il background del bagaglio selezionato con il padding corretto
    .detail--bag {
      .row {
        padding: $grid-gutter-width/2 0;
        margin-left: -20px;
        margin-right: -20px;
        //margin-bottom:$grid-gutter-width/2;
      }
      &.selected .row {
        background-color: var(--light-blue);
      }
      &:not(.selected) .row {
        border-bottom: 1px solid var(--light-gray);
      }
      .col-12 {
        padding-left: 20px;
        padding-right: 20px;
      }
      &:first-child:not(.selected) .row {
        border-top: 1px solid var(--light-gray);
      }
      &:last-child .row {
        border-bottom: 0;
        margin-bottom: 0;
      }
    }

    .badge {
      &-baggage {
        display: inline-block;
      }

      &--icon {
        width: 21px;
        margin-right: 3px;
        display: inline-block;
        vertical-align: middle;
      }

      &--text {
        display: none;

        @include media-breakpoint-up(sm) {
          display: inline-block;
          margin-top: 3px;
          padding-right: 5px;
          display: inline-block;
          vertical-align: middle;
          cursor: default;
        }
      }
    }

    .credit-warning {
      font-size: 16px;
      line-height: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 5px;
    }

    .section {
      &--booking-engine {
        margin: 0;
        position: relative;

        &:after {
          content: '';
          position: absolute;
          top: 0;
          bottom: 50%;
          left: 0;
          right: 0;
          background-color: var(--extra1); // same as header
          z-index: -2;
          display: none;

          @include media-breakpoint-up(lg) {
            display: block;
          }
        }
      }
    }
  }
</style>
